/* eslint-disable no-undef */
import React, {useCallback, useEffect, useState} from 'react';
import './_editCustomer.scss'
import {
  Button,
  ButtonSet,
  Breadcrumb,
  BreadcrumbItem,
  Column,
  DatePicker,
  DatePickerInput,
  Form,
  Grid,
  TextInput,
  Checkbox,
  CheckboxGroup,
  Toggle, Tile,
  FormLabel, Toggletip, ToggletipButton,
  ToggletipContent, SelectItem, Select, Loading
} from "@carbon/react";
import {Information} from '@carbon/react/icons';
import {ADD, useToastContext} from "../../../components/Toast"
import {useRecoilState, useRecoilValue} from "recoil";
import {grpcCustomerServiceSelector} from "../../../state/grpc";
import {customerFormState} from "../../../state/customers_form";
import {Link, useNavigate, useParams} from "react-router-dom";
import RichTextInput from "../../../components/RichTextInput";

const EditCustomer = () => {
  const customersService = useRecoilValue(grpcCustomerServiceSelector)
  const [{
    name,
    code,
    systemEmail,
    warrantyExpiration,
    notes,
    serviceH24,
    saving,
    loading,
    error,
    funnelSystemCode,
    funnelEmail,
    systemType,
    enabled,
    reportEnabled,
    systemLink
  }, setCustomerForm] = useRecoilState(customerFormState);
  const {toastDispatch} = useToastContext();
  const navigate = useNavigate();
  const [funnelSectionToggled, setFunnelSectionToggled] = useState(false)

  // represents the editing state for the customer
  const {customerCode} = useParams();

  const navigateToCustomersList = useCallback(() => {
    navigate('/customers')
  }, [navigate])

  useEffect(() => {
    if (customerCode === undefined) {
      setCustomerForm({
        name: "",
        code: "",
        systemEmail: "",
        warrantyExpiration: "",
        notes: "",
        serviceH24: false,
        loading: false,
        saving,
        error: '',
        funnelSystemCode: '',
        funnelEmail: '',
        systemType: '',
        enabled: true,
        reportEnabled: true,
        systemLink: ''
      })
      return
    }
    const req = new proto.api.GetCustomerRequest()
    req.setCode(customerCode)
    setCustomerForm({loading: true, saving: false, error: ''})
    customersService.getCustomer(req, null, (err, resp) => {
      if (err != null) {
        setCustomerForm({loading: false, saving: false, error: err})
      } else {
        const customer = resp.toObject().customer
        setCustomerForm({
          name: customer.name,
          code: customer.code,
          systemEmail: customer.systemEmail,
          warrantyExpiration: customer.warrantyExpiration,
          notes: customer.notes,
          serviceH24: customer.serviceH24,
          loading: false,
          saving: false,
          error: '',
          funnelSystemCode: customer.funnelSystemCode,
          funnelEmail: customer.funnelEmail,
          systemType: customer.systemType,
          enabled: customer.enabled,
          reportEnabled: customer.reportEnabled,
          systemLink: customer.systemLink
        })
        setFunnelSectionToggled(customer.funnelSystemCode.length > 0)
      }
    })
    // eslint-disable-next-line
  }, [customerCode, customersService, setCustomerForm])

  const handleCustomerSave = (err, resp) => {
    if (err != null) {
      console.error(err)
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione fallita",
          content: "Impossibile salvare il sistema",
          kind: "error",
          caption: err.message
        }
      })
      setCustomerForm({
        name,
        code,
        systemEmail,
        warrantyExpiration,
        notes,
        serviceH24,
        loading,
        saving: false,
        error: err,
        funnelSystemCode,
        funnelEmail,
        systemType,
        enabled,
        reportEnabled,
        systemLink
      })
    } else if (resp != null && resp.array.length > 0) {
      setCustomerForm({
        name,
        code,
        systemEmail,
        warrantyExpiration,
        notes,
        serviceH24,
        loading,
        saving: false,
        error: '',
        funnelSystemCode,
        funnelEmail,
        systemType,
        enabled,
        reportEnabled,
        systemLink
      })
      navigateToCustomersList()
      toastDispatch({
        type: ADD,
        payload: {
          title: "Operazione avvenuta con successo",
          content: "Sistema '" + name + "' salvato con successo",
          kind: "success"
        }
      })
    }
  }

  const onSubmit = (ev) => {
    ev.stopPropagation()
    const req = new proto.api.SaveCustomerRequest()
    let customer = new proto.api.Customer()
    customer.setCode(code)
    customer.setName(name)
    customer.setSystemEmail(systemEmail)
    customer.setWarrantyExpiration(warrantyExpiration)
    customer.setNotes(notes)
    customer.setServiceH24(serviceH24)
    customer.setSystemType(systemType)
    customer.setEnabled(enabled)
    customer.setReportEnabled(reportEnabled)
    customer.setSystemLink(systemLink)
    // save funnel data only if section is toggled
    if (funnelSectionToggled) {
      customer.setFunnelSystemCode(funnelSystemCode)
      customer.setFunnelEmail(funnelEmail)
    }
    req.setCustomer(customer)
    setCustomerForm({
      name,
      code,
      systemEmail,
      warrantyExpiration,
      notes,
      loading,
      saving: true,
      error: '',
      funnelSystemCode,
      funnelEmail,
      systemType,
      enabled,
      reportEnabled,
      systemLink
    })
    if (customerCode === undefined) {
      customersService.createCustomer(req, null, (err, resp) => {
        handleCustomerSave(err, resp)
      })
    } else {
      customersService.updateCustomer(req, null, (err, resp) => {
        handleCustomerSave(err, resp)
      })
    }
  }

  const systemTypes = [
    {
      "key": "Carel PVPRO",
      "value": "Carel PVPRO"
    },
    {
      "key": "Carel_PVPROv2",
      "value": "Carel_PVPROv2"
    },
    {
      "key": "CIMPLICITY",
      "value": "CIMPLICITY"
    },
    {
      "key": "DANFOSS",
      "value": "DANFOSS"
    },
    {
      "key": "DA-PC",
      "value": "DA-PC"
    },
    {
      "key": "DA-PC2",
      "value": "DA-PC2"
    },
    {
      "key": "DIXELL-2",
      "value": "DIXELL-2"
    },
    {
      "key": "FRIGOVENETA",
      "value": "FRIGOVENETA"
    },
    {
      "key": "PLANTWATCHPRO",
      "value": "PLANTWATCHPRO"
    },
    {
      "key": "SUPERCON_ALICOM",
      "value": "SUPERCON_ALICOM"
    },
    {
      "key": "Televis Suite",
      "value": "Televis Suite"
    },
    {
      "key": "XWEB3000",
      "value": "XWEB3000"
    },
    {
      "key": "XWEBEVONEW",
      "value": "XWEBEVONEW"
    },
    {
      "key": "WURM",
      "value": "WURM"
    },
  ]

  if (loading) {
    return (
      <Loading withOverlay={true}/>
    )
  }

  return (
    <Grid fullWidth className="customers-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to='/customers'>Sistemi</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                {customerCode !== undefined ? name : "Nuovo sistema"}
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              {customerCode !== undefined ? "Modifica sistema " + name : "Nuovo sistema"}
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="customers-edit-page__r1">
            <Tile>
              <Form onSubmit={(ev) => onSubmit(ev)}>
                <TextInput
                  id="customer-name"
                  labelText="Nome"
                  placeholder="Nome sistema"
                  required={true}
                  style={{marginBottom: '1rem'}}
                  value={name}
                  type="text"
                  onChange={ev => setCustomerForm({
                    name: ev.target.value,
                    systemEmail,
                    code,
                    warrantyExpiration,
                    notes,
                    loading: false,
                    error: '',
                    funnelSystemCode,
                    funnelEmail,
                    systemType,
                    enabled,
                    reportEnabled,
                    systemLink
                  })}
                />
                <TextInput
                  id="customer-system-email"
                  labelText="Email sistema"
                  placeholder="e.g. sistema@freddosrl.it"
                  required={true}
                  style={{marginBottom: '1rem'}}
                  value={systemEmail}
                  type="text"
                  onChange={ev => setCustomerForm({
                    name,
                    systemEmail: ev.target.value,
                    code,
                    warrantyExpiration,
                    notes,
                    loading: false,
                    error: '',
                    funnelSystemCode,
                    funnelEmail,
                    systemType,
                    enabled,
                    reportEnabled,
                    systemLink
                  })}
                />
                <Select
                  id="customer-system-type"
                  labelText="Tipologia sistema"
                  value={systemType}
                  onChange={ev => setCustomerForm({
                    name,
                    systemEmail,
                    code,
                    warrantyExpiration,
                    notes,
                    loading: false,
                    error: '',
                    funnelSystemCode,
                    funnelEmail,
                    systemType: ev.target.value,
                    enabled,
                    reportEnabled,
                    systemLink
                  })}
                  helperText="Se specifichi una tipologia di sistema, Guardian utilizzerà quella tipologia per mappare gli allarmi associati (senza controllo automatico)">
                  <SelectItem key="" value="" text="Rileva automaticamente"/>
                  {
                    systemTypes.map((it) => (
                      <SelectItem key={it.key} value={it.key} text={it.value.toUpperCase()}/>
                    ))
                  }
                </Select>
                <div style={{marginBottom: '1rem'}}/>
                <TextInput
                  id="customer-system-link"
                  labelText="Link sistema"
                  placeholder="e.g. 172.168.1.1:8080/system/link"
                  required={false}
                  style={{marginBottom: '1rem'}}
                  value={systemLink}
                  type="text"
                  onChange={ev => setCustomerForm({
                    name,
                    systemEmail,
                    code,
                    warrantyExpiration,
                    notes,
                    loading: false,
                    error: '',
                    funnelSystemCode,
                    funnelEmail,
                    systemType,
                    enabled,
                    reportEnabled,
                    systemLink: ev.target.value
                  })}
                />
                <div style={{marginBottom: '1rem'}}/>
                <RichTextInput
                  labelText="Note sistema"
                  value={notes + ""}
                  onChange={(comps) => setCustomerForm({
                    name,
                    systemEmail,
                    code,
                    warrantyExpiration,
                    notes: comps,
                    loading,
                    error,
                    funnelSystemCode,
                    funnelEmail,
                    systemType,
                    enabled,
                    reportEnabled,
                    systemLink
                  })}
                />
                <div style={{marginBottom: '1rem'}}/>
                <DatePicker
                  locale="no"
                  dateFormat="d/m/Y"
                  datePickerType="single"
                  required={true}
                  value={warrantyExpiration}
                  style={{marginBottom: '1rem'}}
                  onClose={(raw, date) => setCustomerForm({
                    name,
                    systemEmail,
                    code,
                    warrantyExpiration: date,
                    notes,
                    loading: false,
                    error: '',
                    funnelSystemCode,
                    funnelEmail,
                    systemType,
                    enabled,
                    reportEnabled,
                    systemLink
                  })}>
                  <DatePickerInput
                    id="customer-warranty-expiration"
                    labelText="Scadenza garanzia"
                    placeholder="dd/mm/yyyy"
                  />
                </DatePicker>
                <CheckboxGroup legendText="Assistenza H24">
                  <Checkbox
                    id="customer-service-h24"
                    labelText="H24"
                    invalidText="Valore non valido"
                    warnText="Attenzione"
                    checked={serviceH24}
                    style={{marginBottom: '1rem'}}
                    onChange={(ev, {checked, id}) => {
                      setCustomerForm({
                        name,
                        systemEmail,
                        code,
                        warrantyExpiration,
                        notes,
                        serviceH24: checked,
                        loading: false,
                        error: '',
                        funnelSystemCode,
                        funnelEmail,
                        systemType,
                        enabled,
                        reportEnabled,
                        systemLink
                      })
                    }}
                  />
                </CheckboxGroup>
                <div className="form-wrapper" style={{marginBottom: '1rem', marginTop: '1rem'}}>
                  <FormLabel>Attivazione sistema</FormLabel>
                  <Toggletip>
                    <ToggletipButton label="Mostra informazioni">
                      <Information/>
                    </ToggletipButton>
                    <ToggletipContent>
                      Se il sistema viene disattivato, tutti i relativi allarmi non verranno più presi in
                      considerazione.
                      Questo significa che non saranno più aggiunti alla lista degli allarmi attivi e non verranno
                      nemmeno
                      inviate le mail agli operatori di turno.
                      Nota bene: gli allarmi già presenti nella lista degli allarmi attivi e nello storico non verranno
                      rimossi.
                    </ToggletipContent>
                  </Toggletip>
                </div>
                <Toggle
                  id="customer-enabled"
                  labelA="Disattivo"
                  labelB="Attivo"
                  toggled={enabled}
                  onToggle={(toggled) => {
                    setCustomerForm({
                      name,
                      systemEmail,
                      code,
                      warrantyExpiration,
                      notes,
                      serviceH24,
                      loading: false,
                      error: '',
                      funnelSystemCode,
                      funnelEmail,
                      systemType,
                      enabled: toggled,
                      reportEnabled,
                      systemLink
                    })
                  }}
                />
                <div className="form-wrapper" style={{marginBottom: '1rem', marginTop: '1rem'}}>
                  <FormLabel>Controllo segnali vita</FormLabel>
                  <Toggletip>
                    <ToggletipButton label="Mostra informazioni">
                      <Information/>
                    </ToggletipButton>
                    <ToggletipContent>
                      Se il flag viene disattivato, per questo sistema non verrà più controllata la presenza di un
                      report.
                      Di conseguenza, anche se nessun report viene spedito a Guardian, questo sistema non verrà aggiunto
                      alla lista dei sistemi Offline.
                      Nota bene: questa configurazione non influisce sulla eventuale ricezione di mail report da parte
                      del
                      sistema. Questo significa, che anche se è disattivato, è possibile che eventuali mail di segnale
                      vita
                      siano comunque registrate nello storico.
                      L'attivazione o la disattivazione di questa configurazione produce effetti immediati sulla tabella
                      dei
                      sistemi offline.
                    </ToggletipContent>
                  </Toggletip>
                </div>
                <Toggle
                  id="customer-report-enabled"
                  labelA="Disattivo"
                  labelB="Attivo"
                  toggled={reportEnabled}
                  onToggle={(toggled) => {
                    setCustomerForm({
                      name,
                      systemEmail,
                      code,
                      warrantyExpiration,
                      notes,
                      serviceH24,
                      loading: false,
                      error: '',
                      funnelSystemCode,
                      funnelEmail,
                      systemType,
                      enabled,
                      reportEnabled: toggled,
                      systemLink
                    })
                  }}
                />
                <div className="form-wrapper" style={{marginBottom: '1rem', marginTop: '1rem'}}>
                  <FormLabel>Super concentratore</FormLabel>
                  <Toggletip>
                    <ToggletipButton label="Mostra informazioni">
                      <Information/>
                    </ToggletipButton>
                    <ToggletipContent>
                      Configura questo sistema come super concentratore. Se attivo, devi configurare il codice sistema e
                      la email
                    </ToggletipContent>
                  </Toggletip>
                </div>
                <Toggle
                  labelA="No"
                  labelB="Si"
                  toggled={funnelSectionToggled}
                  onToggle={(toggled) => {
                    setFunnelSectionToggled(toggled)
                  }}
                  id="toggle-1"
                />
                <div style={{marginBottom: '1rem'}}/>
                <Tile className={funnelSectionToggled ? "funnel-tile-shown" : "funnel-tile-hidden"}>
                  <FormLabel style={{marginBottom: '1rem'}}>Dati Super concentratore</FormLabel>
                  <TextInput
                    id="customer-funnel-system-code"
                    labelText="Codice sistema"
                    placeholder="Codice sistema super concentratore"
                    required={funnelSectionToggled}
                    style={{marginBottom: '1rem'}}
                    value={funnelSystemCode}
                    type="text"
                    onChange={ev => setCustomerForm({
                      name,
                      systemEmail,
                      code,
                      warrantyExpiration,
                      notes,
                      loading: false,
                      error: '',
                      funnelSystemCode: ev.target.value,
                      funnelEmail,
                      systemType,
                      enabled,
                      reportEnabled,
                      systemLink
                    })}
                  />
                  <TextInput
                    id="customer-funnel-email"
                    labelText="Email"
                    placeholder="e.g. superconcentratore@freddosrl.it"
                    required={funnelSectionToggled}
                    style={{marginBottom: '1rem'}}
                    value={funnelEmail}
                    type="text"
                    onChange={ev => setCustomerForm({
                      name,
                      systemEmail,
                      code,
                      warrantyExpiration,
                      notes,
                      loading: false,
                      error: '',
                      funnelSystemCode,
                      funnelEmail: ev.target.value,
                      systemType,
                      enabled,
                      reportEnabled,
                      systemLink
                    })}
                  />
                </Tile>
                <ButtonSet className="customers-edit-page__r1-form-btn">
                  <Button onClick={navigateToCustomersList} kind="secondary">
                    Annulla
                  </Button>
                  <Button disabled={saving} type="submit" kind="primary">
                    {saving ? "Salvataggio in corso.." : "Salva"}
                  </Button>
                </ButtonSet>
              </Form>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default EditCustomer